import App from "../../../core/src/App";
import VendorModel from "../../../src/model/VendorModel";
import UIController from "../../src/ui/UIController";
import { UIStates } from "../../src/ui/UIStates";
import { DefaultLayers } from "../../src/utils/Layers";
import ViewManager from "../../src/utils/ViewManager";
import ReelGroup from "../../src/views/ReelGroup";
import { Tween } from "../Tween";
import { Commands } from "../commands/CommandEnum";
import CommandManager from "../commands/CommandManager";
import GameEvents from "../const/GameEvents";
import AutoplayModel from "../model/AutoplayModel";
import BetModel from "../model/BetModel";
import ErrorModel from "../model/ErrorModel";
import SpinModel from "../model/SpinModel";
import { UIUpdateEvent } from "../ui/UIUpdateEvents";
import ConsoleUtil from "../utils/ConsoleUtil";
import { State } from "./State";

export default abstract class SpinStartState extends State {
    public enter(): void {
        super.enter();

        const scene = ViewManager.getLayer(
            DefaultLayers.Reels
        ).getCurrentScene();
        const reelGroup = scene.getSubView("ReelGroup") as ReelGroup;
        reelGroup.hideLinesAndInfo(true);
        if (AutoplayModel.isAutoSpinActive()) {
            if (!SpinModel.isInFreespins()) {
                UIController.setMode(UIStates.AUTO);
                UIController.setState(UIStates.AUTO);
            }
        } else {
            UIController.setState(UIStates.SPIN);
        }
        this.startSpin();
        if (
            !SpinModel.isInFreespins() &&
            !AutoplayModel.isAutoSpinActive() &&
            !SpinModel.inFreegames() &&
            !SpinModel.isInRespins()
        ) {
            CommandManager.execute(Commands.CLEAR_WIN);
        }

        if (
            SpinModel.cascades?.length > 0 &&
            (!SpinModel.cascades[SpinModel.cascadeIndex]?.winAmount ||
                SpinModel.hasFreespinsWon())
        ) {
            CommandManager.execute(Commands.CLEAR_CASCADE_HISTORY);
        }
    }

    protected startSpin() {
        this.updateWins();

        if (AutoplayModel.hasAutospinStarted()) {
            App.timeline.add(
                Tween.delayedCall(App.config.autoSpinDelay, () => {
                    if (!SpinModel.isInFreespins()) {
                        CommandManager.execute(Commands.CLEAR_WIN);
                    }

                    this.initReel();
                    this.sendRequest();
                }),
                App.timeline.time
            );
        } else {
            this.initReel();
            this.sendRequest();
        }
        this.emitEvents();
    }

    protected updateWins(): void {
        if (SpinModel.inFreegames()) {
            // TODO: remove this code! Never assign SpinModel data directly!
            // Also: VendorModel is placed at vendor_core, not at core!!!
            // SpinModel.accumulatedWin = VendorModel.freeGames.win;
            CommandManager.execute(Commands.UPDATE_WIN, VendorModel.freeGames);
        }
    }

    protected emitEvents(): void {
        App.dispatcher.emit(GameEvents.START_SPIN);
        App.dispatcher.emit(GameEvents.LINES_BOX_UPDATE);
    }

    abstract sendRequest(): void;

    protected initReel() {
        let reelGroup = ViewManager.getLayer(DefaultLayers.Reels)
            .getCurrentScene()
            .getSubView("ReelGroup") as ReelGroup;
        reelGroup.spin();
    }

    protected onResponse(data?: any) {
        SpinModel.update(data);
        ErrorModel.update(data);

        if (AutoplayModel.isAutoSpinActive()) {
            CommandManager.execute(Commands.DECREMENT_AUTOPLAY);
        }

        if (!SpinModel.isInFreespins() && !SpinModel.isInRespins()) {
            BetModel.update(data);
            UIController.updateFields(UIUpdateEvent.Balance);
        } else {
            this.anounce();
        }

        this.updateFields();
        this.exit();
    }

    protected updateFields() {
        if (SpinModel.isInFreespins()) {
            CommandManager.execute(
                Commands.UPDATE_FREE_SPINS,
                SpinModel.freespinsNum.toString()
            );
        } else {
            // CommandManager.execute(Commands.CLEAR_WIN);
        }
        CommandManager.execute(Commands.UPDATE_BALANCE);
    }

    protected anounce() {
        if (
            ViewManager.getLayer(DefaultLayers.Banners).getCurrentScene()
                .sceneTextFields
        ) {
            const announcer = ViewManager.getLayer(DefaultLayers.Banners)
                .getCurrentScene()
                .sceneTextFields.get("anouncer");
            announcer.visible = true;
            announcer.text = SpinModel.freespinsNum + " spins left";
        } else {
            ConsoleUtil.warn("[UI] MISSING UI ELEMENT -> Free spins announcer");
        }
    }
}
